module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "specials"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticClass: "layout_fullwidth_padding"
  }, [_c('h2', {
    staticClass: "page_title"
  }, [_vm._v("SPECIALS")]), _vm._v(" "), _c('a', {
    staticClass: "back-link",
    attrs: {
      "href": "inventory"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left icon"
  }), _vm._v("back to full inventory")]), _vm._v(" "), (!_vm.isLoaded) ? _c('div', {
    staticClass: "loader-container",
    attrs: {
      "color": "#f9f300"
    }
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": "#f9f300"
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.specials), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "inventory-list-item"
    }, [_c('InventoryListItem', {
      attrs: {
        "backUrl": _vm.backUrl,
        "item": item,
        "borderStyle": _vm.borderStyle
      }
    })], 1)
  }), _vm._v(" "), (_vm.specials.length === 0) ? _c('div', {
    staticClass: "padging-container"
  }, [_c('span', [_vm._v("NO RESULT")])]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c78d3bc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c78d3bc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/inventory/specials.vue
// module id = 812
// module chunks = 0